import * as React from 'react';
import { IconBase } from 'react-icons';
function DeprecatedCloseIcon(props, svgRef) {
    return (
        <IconBase fill="currentColor" viewBox="0 0 14 14" ref={svgRef} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 5.586L12.293.293a1 1 0 111.414 1.414L8.414 7l5.293 5.293a1 1 0 01-1.414 1.414L7 8.414l-5.293 5.293a1 1 0 01-1.414-1.414L5.586 7 .293 1.707A1 1 0 011.707.293L7 5.586z"
            />
        </IconBase>
    );
}
const ForwardRef = React.forwardRef(DeprecatedCloseIcon);
export default ForwardRef;
